export default __webpack_public_path__ + "static/media/logo.2300d3c9.png";